import request from '../request';

const { VITE_ANALYTICS_URL_ROOT } = process.env;

export function fetch(params, options) {
  return [request, 'get', 'analytics/reports', params, options];
}

export function read(id: string, options: any) {
  return [request, 'get', `analytics/reports/${id}`, null, options];
}

export function create(payload: any) {
  return request('post', 'analytics/reports', payload);
}

export function update(id: string, payload: any) {
  return request('put', `analytics/reports/${id}`, payload);
}

export function clone(id: string, payload: any) {
  return request('post', `analytics/reports/${id}/clone`, payload);
}

export function destroy(id: string) {
  return request('delete', `analytics/reports/${id}`);
}

export function downloadPdf(reportId: string, params = {} as any) {
  const query = new URLSearchParams(params).toString();
  return request('get', `reports/${reportId}/pdf?${query}`, null, {
    responseType: 'blob',
    baseURL: VITE_ANALYTICS_URL_ROOT
  });
}

// Render a report PDF on the fly from a configuration payload, without persisting
// a report. Mirrors the analytics `POST /reports/export` endpoint used by the
// report preview modal; returns the PDF as a blob for client-side download.
export function exportPdf(payload: any, { locale }: { locale?: string } = {}) {
  return exportReport(payload, 'pdf', { locale });
}

// Render a report file on the fly (the XLSX export isn't stored with the report assets)
export function exportReport(payload: any, format: 'pdf' | 'csv' | 'xlsx', { locale }: { locale?: string } = {}) {
  const query = new URLSearchParams({ format, ...(locale ? { locale } : {}) }).toString();
  return request('post', `reports/export?${query}`, payload, {
    responseType: 'blob',
    baseURL: VITE_ANALYTICS_URL_ROOT
  });
}
